/* eslint-disable max-len */
import React, { SVGAttributes } from 'react';

export const Clock = (props: SVGAttributes<unknown>): JSX.Element => (
  <svg width='18' height='18' viewBox='0 0 18 18' fill='none' {...props}>
    <path
      d='M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M9 4V9L12.3333 10.6667'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
